/**
 * Local state container for external PA orders table rows and loading/error lifecycle.
 */
import { useState } from "react";
import { PostgresResponseForMedicalPaOrders } from "../../../../../data-model/postgresResponseForMedicalPaOrders";

/**
 * Async state for external PA orders list data returned from Postgres search.
 *
 * @property data - Latest paginated response, when a fetch has completed
 * @property loading - True while a blocking (initial or full) fetch is in progress
 * @property error - Error message when the last request failed
 * @property showinLineLoader - True while a non-blocking next-page fetch is in progress
 */
export interface ExternalTableState {
  data?: PostgresResponseForMedicalPaOrders;
  loading?: boolean;
  error?: string;
  showinLineLoader?: boolean;
}

/**
 * Provides local state for external PA orders table data and its async lifecycle.
 *
 * @returns Table data array with setter, and external table state (data/loading/error) with setter
 */
export const useExternalTableData = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [externalTableState, setExternalTableState] =
    useState<ExternalTableState>({
      data: undefined,
      loading: false,
      error: undefined,
      showinLineLoader: false,
    });

  return {
    externalTableState,
    setExternalTableState,
    tableData,
    setTableData,
  };
};
